import { IsBase58 } from '../decorators/is-base-58';

export class SolanaSignMessageRequest {
  @IsBase58()
  public readonly message!: string; // the message, base58 encoded
}
